import React, { Component } from 'react'
import Select from 'react-select'

class RolesType extends Component {
    constructor() {
        super()
        this.state = {
            rolesTypeList:[ {"label":"EMPLOYEE","value":"EMPLOYEE"},{"label":"SYSTEM","value":"SYSTEM"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.rolesTypeList}
                placeholder="Select Role Type"
                onChange={(e) => { (e) ? this.props.rolesTypeChange(e) : this.props.rolesTypeChange([])}}
                />
            </div>
        )
    }
}

export default RolesType


// WEBPACK FOOTER //
// ./src/modules/Roles/Components/DropDowns/RolesType.js